export function getView(segments) {
  return segments > 2
}
